export class SpareRequest {
    constructor(id?: string, bankId?: string, inventoryId?: string, dispatch_date?: Date,requested_date ? : Date,merchantId?: string, terminalType?: string,primaryItem?: string, secondaryItem?: string, tertiaryItem?: string, detailItem?: string,
        bankName?: string, requested_Quantity?: number, dispatch_Quantity?: number, location?: string, cancelRemarks?: string) {
        this.id = id!;
        this.bankId = bankId!;
        this.bankName = bankName!;

        this.primaryItem = primaryItem!;
        this.secondaryItem = secondaryItem!;
        this.tertiaryItem = tertiaryItem!;
        this.detailItem = detailItem!;
        this.inventoryId = inventoryId!;
        this.merchantId = merchantId!;
        this.terminalType = terminalType!;
        this.requested_Quantity = requested_Quantity!;
        this.dispatch_Quantity = dispatch_Quantity!;
        this.requested_date = requested_date!;
        this.dispatch_date = dispatch_date!;
        this.location = location!;
        this.cancelRemarks = cancelRemarks!;

    }



    public id: string;
    public bankId: string;
    public location :string;
    public inventoryId: string;
    public primaryItem: string;
    public secondaryItem: string;
    public tertiaryItem: string;
    public detailItem: string;
    public requested_date : Date;
    public dispatch_date :Date;

    public merchantId: string;
    public terminalType: string;
    public bankName: string;
    public requested_Quantity: number;
    public dispatch_Quantity: number;
    public cancelRemarks: string;
}
